export enum AddressEndpointsEnum {
  GET_ALL_ADDRESSES = "/Address",
  ADD_ADDRESS = "/Address",
  DELETE_ADDRESS = "/Address",
}
